import { render, staticRenderFns } from "./DatosUsuario.vue?vue&type=template&id=47711845"
import script from "./DatosUsuario.vue?vue&type=script&lang=js"
export * from "./DatosUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports